import SEO from '../components/SEO/SEO'
import { useState, useEffect } from 'react'
import Layout from '../layout/Layout'
import { Disclosure } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/outline'
import ContactForm from '../components/ContactForm/ContactForm'
import ButtonLink from '../components/ButtonLink/ButtonLink'

const AdmissionNotification = () => {
  const [formList, SetFormList] = useState(null)
  const [loading, SetLoading] = useState(true)
  const [error, SetError] = useState(null)

  const faqs = [
    {
      question: "What's the best thing about Switzerland?",
      answer:
        "I don't know, but the flag is a big plus. Lorem ipsum dolor sit amet consectetur adipisicing elit. <br /> Quas cupiditate laboriosam fugiat.",
    },
  ]

  function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
  }

  return (
    <>
      <SEO />
      <Layout>
        <div className="relative">
          <div className="absolute inset-x-0 bottom-0 bg-gray-100 h-1/2" />
          <div className="mx-auto">
            <div className="relative">
              <div className="absolute inset-0">
                <img
                  className="object-cover w-full h-full"
                  src="videocallAtDesk.png"
                  alt="Healthcare provider on a video call"
                />
              </div>
              <div className="relative max-w-screen-xl px-4 py-16 mx-auto md:py-16 lg:py-32">
                <h1 className="text-3xl tracking-tight md:text-5xl text-darkBlue">
                  Retrospective Reviews
                </h1>
                <p className="max-w-lg mt-6 text-xl text-grey sm:max-w-3xl">
                  Process of determining coverage after treatment has been
                  given.
                </p>
              </div>
            </div>
          </div>
        </div>

        <section>
          <div className="max-w-screen-xl px-4 py-12 mx-auto sm:px-6 lg:px-8 text-grey">
            <Disclosure as="div" defaultOpen>
              {({ open }) => (
                <>
                  <dt className="text-lg">
                    <Disclosure.Button className="flex items-start justify-between w-full text-left">
                      <span className="text-xl text-blue">
                        What is a retrospective review?
                      </span>
                      <span className="flex items-center ml-6 h-7">
                        <ChevronDownIcon
                          className={classNames(
                            open ? '-rotate-180' : 'rotate-0',
                            'h-6 w-6 transform'
                          )}
                          aria-hidden="true"
                        />
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="pr-12 mt-2 text-base">
                    <p>
                      A retrospective review is the process of determining
                      coverage after treatment has been given.
                    </p>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
            <br />
            <Disclosure as="div" className="pt-6" defaultOpen>
              {({ open }) => (
                <>
                  <dt className="text-lg">
                    <Disclosure.Button className="flex items-start justify-between w-full text-left">
                      <span className="text-xl text-blue">
                        When is retrospective review available?
                      </span>
                      <span className="flex items-center ml-6 h-7">
                        <ChevronDownIcon
                          className={classNames(
                            open ? '-rotate-180' : 'rotate-0',
                            'h-6 w-6 transform'
                          )}
                          aria-hidden="true"
                        />
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="pr-12 mt-2 text-base">
                    <p>
                      Retrospective review is available to a provider when all
                      of the following criteria is met:
                    </p>
                    <br />
                    <ul className="ml-8 list-disc">
                      <li>
                        Confirming member eligibility and the availability of
                        benefits.
                      </li>
                      <li>
                        The service has not been submitted for payment or
                        processing.
                      </li>
                    </ul>
                    <br />
                    AND one of the following:
                    <br />
                    <br />
                    <ul className="ml-8 list-disc">
                      <li>
                        If the health plan authorized an initial inpatient
                        request, a subsequent request will be accepted for
                        review within 3 business days of the last approved day.
                      </li>
                      <li>
                        An additional service was identified as necessary when
                        the original authorized service was performed. Requests
                        for this additional service will be accepted within 5
                        business days of the performed service.
                      </li>
                    </ul>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
            <br />
            <Disclosure as="div" className="pt-6" defaultOpen>
              {({ open }) => (
                <>
                  <dt className="text-lg">
                    <Disclosure.Button className="flex items-start justify-between w-full text-left">
                      <span className="text-xl text-blue">
                        Retrospective review is not available for
                      </span>
                      <span className="flex items-center ml-6 h-7">
                        <ChevronDownIcon
                          className={classNames(
                            open ? '-rotate-180' : 'rotate-0',
                            'h-6 w-6 transform'
                          )}
                          aria-hidden="true"
                        />
                      </span>
                    </Disclosure.Button>
                  </dt>
                  <Disclosure.Panel as="dd" className="pr-12 mt-2 text-base">
                    <ul className="ml-8 list-disc">
                      <li>
                        Elective ambulatory or inpatient services on the prior
                        authorization list for which prior authorization did not
                        occur before providing the service.
                      </li>
                      <li>
                        Services requiring notification within 3 business days that did
                        not meet notification requirements (notification of
                        inpatient admissions is required within 3 business days of
                        admission date).
                      </li>
                      <li>
                        {' '}
                        Services not included on the prior authorization list.{' '}
                      </li>
                      <li>
                        Services that do not require prior authorization under
                        the terms of a member’s plan.
                      </li>
                    </ul>
                  </Disclosure.Panel>
                </>
              )}
            </Disclosure>
          </div>
        </section>
      </Layout>
    </>
  )
}

export default AdmissionNotification
